import { render, staticRenderFns } from "./AcceptTOCs.vue?vue&type=template&id=016555a9&scoped=true"
import script from "./AcceptTOCs.vue?vue&type=script&lang=js"
export * from "./AcceptTOCs.vue?vue&type=script&lang=js"
import style0 from "./AcceptTOCs.vue?vue&type=style&index=0&id=016555a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016555a9",
  null
  
)

export default component.exports